import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'immutable';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TranslateTemplateFieldGroupLabel = styled.span.withConfig({
  displayName: "TranslateTemplateFooterLinksSection__TranslateTemplateFieldGroupLabel",
  componentId: "sc-1r6v3m8-0"
})(["font-size:16px;font-weight:600;"]);
export default function TranslateTemplateFooterLinksSection(props) {
  const {
    title,
    values,
    languages
  } = props;
  const footerLinks = values.get(languages[0]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: footerLinks.map((link, idx) => {
      const {
        uuid
      } = link.toJS();
      return /*#__PURE__*/_jsx(UIAccordionItem, {
        className: "m-top-4",
        title: /*#__PURE__*/_jsxs(TranslateTemplateFieldGroupLabel, {
          children: [title, " ", `${idx + 1}`]
        }),
        children: languages.map((lang, langIdx) => {
          const isPrimary = langIdx === 0;
          const languageName = getLanguageNameFromCode(lang);
          const onChange = e => props.onChange(lang, idx, uuid, e);
          const value = values.get(lang, List()).toJS();
          const currItem = value.find(translation => translation.uuid === uuid);
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(UIFormControl, {
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.footerLinksFieldLabels.name",
                options: {
                  languageName
                }
              }),
              labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
              }) : null,
              children: /*#__PURE__*/_jsx(UITextInput, {
                name: "name",
                onChange: onChange,
                readOnly: isPrimary,
                value: currItem ? currItem.name : ''
              })
            }, uuid), /*#__PURE__*/_jsx(UIFormControl, {
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.footerLinksFieldLabels.url",
                options: {
                  languageName
                }
              }),
              labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
              }) : null,
              verticalSeparation: "flush",
              children: /*#__PURE__*/_jsx(UITextInput, {
                name: "url",
                onChange: onChange,
                readOnly: isPrimary,
                value: currItem ? currItem.url : ''
              })
            }, uuid)]
          });
        })
      }, uuid);
    }).toArray()
  });
}